import DropdownField from '@payaca/components/dropdownField/DropdownField';
import { AllSystemRoles } from '@payaca/permissions/default-role.config';
import {
  getUserRoles,
  userHasRequiredPermission,
} from '@payaca/permissions/permissions.utils';
import { FunctionComponent, useMemo, type JSX } from 'react';
import { useAccountUsers } from '../../../utils/storeHooks';
type Props = {
  currentAssignedUser?: any;
  onAssignedUserChange: (userId: string) => void;
  label?: string;
  assigneeRequiredPermission?: string[];
};

const AssignmentDropdown: FunctionComponent<Props> = ({
  currentAssignedUser,
  onAssignedUserChange,
  label,
  assigneeRequiredPermission,
}: Props): JSX.Element | null => {
  const accountUsers = useAccountUsers();

  const getUserRolesForUserSystemRole = (userSystemRole: AllSystemRoles) => {
    return getUserRoles(userSystemRole, {});
  };

  const selectItems = useMemo(() => {
    const items = accountUsers
      .filter((x) => {
        const userRoles = getUserRolesForUserSystemRole(
          x.systemRole as AllSystemRoles
        );
        const assigneeUserHasPermission = assigneeRequiredPermission?.length
          ? userHasRequiredPermission(userRoles, assigneeRequiredPermission)
          : true;
        return (!x.deactivatedAt || x.inviteToken) && assigneeUserHasPermission;
      })
      .map((user: any) => {
        return {
          label: user.name,
          value: user.id,
        };
      });
    items.push({ label: 'Unassigned', value: '' });
    return items;
    // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React hook useMemo depends on `getUserRolesForUserSystemRole`, which changes every render
  }, [accountUsers, assigneeRequiredPermission, getUserRolesForUserSystemRole]);

  return accountUsers.length ? (
    <div className="assignment-control">
      {accountUsers.length && (
        <DropdownField
          options={selectItems}
          name="assignedUserId"
          onChange={(value: { [key: string]: any }) =>
            onAssignedUserChange(value.assignedUserId)
          }
          value={
            currentAssignedUser?.id
              ? currentAssignedUser.id
              : currentAssignedUser || ''
          }
          label={label}
        />
      )}
    </div>
  ) : null;
};

export default AssignmentDropdown;
